import { RouterStore } from '@estee/elc-router';
import { ACCOUNT_FORGOT_PASSWORD_URL } from '~routes/routes';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';

export class ForgotPasswordUseCase {
    private routerStore: RouterStore;

    constructor() {
        this.routerStore = diContainer.get(serviceNames.routerStore);
    }

    public execute = () => {
        // TODO: not always changing location, might sent email to recover account
        this.routerStore.changeLocation(ACCOUNT_FORGOT_PASSWORD_URL);
    };
}
